import * as React from "react";

import { toInteger } from "lodash";

import { newSetKeyValueChange } from "../../../../helpers/Doc/changes";

interface DocEditHeaderAssistantIdInputProps {
  contentKey: string;
  default: string;
  disableMetadataEdit: boolean;
  documentContext?: DocumentContext;
  editingContext: EditingContextInEditor;
  label: string;
  uid: string;
  value: number;
}

interface DocEditHeaderAssistantIdInputState {
  inputValue?: string;
}

function formatAssistantKind(kind: string) {
  return kind.replace(/_/g, " ").replace(/\b\w/g, (character) => character.toUpperCase());
}

function assistantKindForId(
  documentContext: DocumentContext | undefined,
  assistantId: number | undefined,
) {
  if (!assistantId) {
    return null;
  }

  return documentContext?.aiAssistantsById?.[assistantId]?.kind || null;
}

export default class DocEditHeaderAssistantIdInput extends React.Component<
  DocEditHeaderAssistantIdInputProps,
  DocEditHeaderAssistantIdInputState
> {
  constructor(props: DocEditHeaderAssistantIdInputProps) {
    super(props);
    this.state = {};
  }

  componentWillUnmount() {
    this.handleBlur();
  }

  handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ inputValue: e.target.value });
  }

  handleBlur() {
    if (this.state.inputValue !== undefined) {
      const newValue = toInteger(this.state.inputValue);
      this.props.editingContext.addChange(
        newSetKeyValueChange(this.props.uid, this.props.contentKey, newValue),
      );
      this.setState({ inputValue: undefined });
    }
  }

  render() {
    const displayValue =
      this.state.inputValue !== undefined
        ? this.state.inputValue
        : this.props.value ?? this.props.default ?? "";
    const assistantId = toInteger(displayValue);
    const assistantKind = assistantKindForId(this.props.documentContext, assistantId);
    const inputId = `${this.props.uid}-${this.props.contentKey}-assistant-id`;

    return (
      <div className="doc-edit-header-input doc-edit-header-assistant-id-input" style={{paddingTop:"10px"}}>
        <label htmlFor={inputId}>{this.props.label}</label>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <input
            id={inputId}
            type="text"
            value={displayValue}
            disabled={this.props.disableMetadataEdit}
            onChange={this.handleChange.bind(this)}
            onBlur={this.handleBlur.bind(this)}
          />
          {assistantKind && (
            <span className="doc-edit-header-assistant-id-type" style={{minWidth:"200px"}}>
              {formatAssistantKind(assistantKind)}
            </span>
          )}
        </div>
      </div>
    );
  }
}
